module.exports = __webpack_public_path__ + "static/media/messages-cercle.ed370c5b.png";